import store from  "../../store/index";
import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'

export default {
    methods:{
        changeStatusFromIncompleteToComplete(idlab,kind){



            var tmpName = null
            const  statusLabs  = store.getters['master_data/getStatusLabs']

            if(statusLabs.length === 0){
                store.dispatch('master_data/fetchStatusLabs')
                    .then(()=>{
                        tmpName = statusLabs.find(dat=>{
                            return  dat.id === 6
                        })
                })

            }else{
                tmpName = statusLabs.find(dat=>{
                    return  dat.id === 6
                })
            }



            if(kind.toUpperCase() === 'CYTOLOGY'){
                 this.dataCytoSpecLN.status.id = 6
                 this.dataCytoSpecLN.status.name = tmpName.name
            }
            if(kind.toUpperCase() === 'BIOPSY'){
                 this.dataBiopsySpecLN.status.id = 6
                 this.dataBiopsySpecLN.status.name = tmpName.name
            }



            // change to server
            const datTo = {
                "idlab" : idlab
            }
            const vm = this
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
            axios.post(`${getBaseURLforBackEnd()}/api/changestatuslabnonfromincompletetocomplete`,datTo,getConfigAxios())
                .then((res)=>{
                    // remove Tray again
                    const payloadDatTo = {
                        "user_id": this.user_id,
                        "status_id": 5
                    }
                    vm.fetchMyJobsTray(payloadDatTo)

                    vm.$buefy.dialog.alert({
                        title: 'Status has changed',
                        message: `${res.data.msg}`,
                        confirmText: 'OK'
                    })
                })





        }
    },
}